import { useState } from 'react'
import { Check, FilePlus2 } from 'lucide-react'
import { trackEvent, EVENTS } from '@/services/analytics'
import { ASSISTANT_PERSONA } from '@/features/companion/companion-personas'
import { splitMentionPreamble } from './mention-preamble'

interface RequestGuideButtonProps {
  /** The how-to topic the guide search came back empty for. */
  topic: string
  /** The user's message that led here (may carry an @-mention preamble). */
  question: string
  page: string
}

/**
 * "Request this": when the AI had no guide for a how-to question, the user
 * can ask for one. Each request lands in PostHog as
 * `companion_content_requested`, the backlog the FAQ bank is built from.
 */
export function RequestGuideButton({ topic, question, page }: RequestGuideButtonProps) {
  const [requested, setRequested] = useState(false)
  if (requested) {
    return (
      <span className="inline-flex items-center gap-1.5 px-1 text-xs text-muted-foreground">
        <Check size={12} />
        Requested. Thanks, we'll add a guide for this.
      </span>
    )
  }
  return (
    <button
      type="button"
      onClick={() => {
        trackEvent(EVENTS.COMPANION_CONTENT_REQUESTED, {
          topic,
          question: splitMentionPreamble(question).body.trim().slice(0, 500),
          page,
          persona: ASSISTANT_PERSONA,
        })
        setRequested(true)
      }}
      className="inline-flex items-center gap-1.5 rounded-md border border-border bg-muted/40 px-2.5 py-1 text-xs font-medium text-foreground transition-colors hover:bg-hover"
    >
      <FilePlus2 size={12} />
      Request this guide
    </button>
  )
}
